import moment from "moment";

const task = {
  id: "",
  date: "",
  contract: "",
  organization: "",
  employee: "",
  startTime: "",
  endTime: "",
  status: "",
  comment: "",
};

function useContractTasks() {
  const start = ({ contract }) => moment(contract.contractStartDate).valueOf();
  const end = ({ contract }) => moment(contract.contractEndDate).valueOf();

  const taskStatus = ({ task }) => task.status || "Unknown status";
  const findWeeks = ({ contract }) => {
    const monday = moment(start({ contract })).startOf("isoWeek");

    const dt = monday;
    const list = [];
    while (end({ contract }) >= dt.valueOf()) {
      const from = monday.valueOf();
      const temp = monday.add(6, "days").valueOf();
      const to = temp >= end({ contract }) ? end({ contract }) : temp;

      list.push({
        from: from < start({ contract }) ? start({ contract }) : from,
        to,
      });
      monday.add(1, "days");
    }

    return list;
  };

  const findCurrentTaskSlots = ({ task }) => {
    const date = task.date;
    const employees = task.employee;
    const list = employees.map((emp) => {
      const from = moment(
        moment(date).format("DD/MM/YYYY") + task.startTime,
        "DD/MM/YYYY hh:mma"
      ).toDate();
      const to = moment(
        moment(date).format("DD/MM/YYYY") + task.startTime,
        "DD/MM/YYYY hh:mma"
      ).toDate();
      return {
        employee: emp,
        from,
        to,
      };
    });
    return list;
  };
  const findDays = ({ from, to, contractTasks, contract }) => {
    const diff = moment(to).diff(from, "days");
    const list = [];
    let start = moment(from);
    const startDate = moment(contract.contractStartDate);
    for (let i = 0; i <= diff; i++) {
      const dt = start.add(i === 0 ? 0 : 1, "day");
      const found = contractTasks.find((i) => {
        return moment(i.date).valueOf() === dt.valueOf();
      });

      if (startDate.valueOf() > dt.valueOf()) {
      } else {
        if (found) list.push({ ...found, date: dt.valueOf(), occupied: true });
        if (!found) list.push({ ...task, date: dt.valueOf() });
      }
    }
    return list;
  };

  const availableDays = ({ contract }) => {
    const weeks = findWeeks({ contract });

    return weeks.map((dt) => {
      const diff = moment(dt.to).diff(dt.from, "days");

      const list = [];
      let start = moment(dt.from);
      const startDate = moment(contract.contractStartDate);
      for (let i = 0; i <= diff; i++) {
        const dt = start.add(i === 0 ? 0 : 1, "day");
        const found = contract.contractTasks.find((i) => {
          return moment(i.date).valueOf() === dt.valueOf();
        });

        if (startDate.valueOf() > dt.valueOf()) {
        } else {
          if (!found) list.push({ ...task, date: dt.valueOf() });
        }
      }
      return list;
    });
  };

  return {
    findWeeks,
    findDays,
    availableDays,
    taskStatus,
    findCurrentTaskSlots,
  };
}

export default useContractTasks;
